import { render, staticRenderFns } from "./EmailGroupEvents.vue?vue&type=template&id=7283673d&"
import script from "./EmailGroupEvents.vue?vue&type=script&lang=ts&"
export * from "./EmailGroupEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports